//
// SASReport.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./BIRDModel";
import "./BIRDSchema";
import "./results/Result";
import "./dataDefinition/DataDefinition";
import "./dataSource/DataSource";
import "./textTemplate/TextTemplate";
import "./visualElements/VisualElement";
import "./visualElements/compositeVisuals/CompositeVisual";
import "./promptDefinitions/PromptDefinition";
import "./view/View";
import "./visualElements/actions/AbstractAction";
import "./interactions/Interaction";
import "./conditions/Condition";
import "./media/MediaDefinitionResource";
import "./media/MediaScheme";
import "./MediaTarget";
import "./common/BIRDProperty";
import "./ReportPart";
import "./dataSourceMapping/DataSourceMapping";
import "./localization/Localization";
import "./grouping/Grouping";
import "./results/sorting/CustomSort";
import "./export/Export";
import "./history/History";
import "./dataStyleGroups/DataStyleGroupElement";
import "./dataSource/codedItem/ModelDataSource";
import "./state/SASReportState";
import "./ViewerCapabilities";
import "./externalResources/ExternalResource";
import "./dataSource/supplement/MetadataSupplement";
import "@sas-dvr/ltjs-commons/styles/NamedStyleMap";

var SASReport = createModule("BIRD::SASReport", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        localization: 1,
        dataDefinitions: [1],
        mediaTargets: [1],
        mediaSchemes: [1],
        customSorts: [1],
        dataSourceMappings: [1],
        viewerCapabilities: 1,
        lastModifiedApplication: 7,
        mediaDefinitionResource: 1,
        nextUniqueNameIndex: 4,
        promptDefinitions: [1],
        textTemplates: [1],
        implicitInteractions: 7,
        visualElements: [1],
        interactions: [1],
        features: 7,
        xmlns: 1,
        view: 1,
        dateCreated: 7,
        createdVersion: 7,
        reportState: 1,
        results: [1],
        dataSources: [1],
        exportProperties: [1],
        modelDataSources: [1],
        namedStyleMap: 1,
        metadataSupplement: 1,
        summaryElement: 7,
        createdApplication: 7,
        dateModified: 7,
        resourceName: 7,
        label: 7,
        history: 1,
        disabledActions: 7,
        dataStyleGroups: [1],
        compositeVisuals: [1],
        groupings: [1],
        createdLocale: 7,
        externalResources: [1],
        conditions: [1],
        actions: [1],
        reportParts: [1],
        properties: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SASReport;
